import type { HttpProgressEvent, HttpResponse } from '@angular/common/http';
import type { AdditionalPermissions } from '@wizbii-utils/angular/webservices';
import type { FileWebServiceInterface } from 'node_modules/@wizbii-components/bo-angular-ui/lib/form/file-picker/services/file.web-service.interface';
import type { Observable } from 'rxjs';

import { HttpClient, HttpEventType } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { concat, of } from 'rxjs';
import { distinct, filter, map, shareReplay } from 'rxjs/operators';

@Injectable()
export class FileWebService implements FileWebServiceInterface {
  readonly #httpClient = inject(HttpClient);

  get(url: string): Observable<Blob> {
    return this.#httpClient.get(url, { responseType: 'blob' });
  }

  getFileUrl(url: string): Observable<string> {
    return of(url);
  }

  post(
    file: Blob,
    _isPublic?: boolean,
    _additionalPermissions?: AdditionalPermissions,
    applySvgCurrentColor = true
  ): Observable<number | string> {
    const body: any = new FormData();
    body.append('file', file);

    const result$ = this.#httpClient
      .post(this.buildUploadUrl(applySvgCurrentColor), body, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(shareReplay(1));

    const progress$ = result$.pipe(
      filter((event) => event.type === HttpEventType.UploadProgress),
      map((event) => event as HttpProgressEvent),
      map((event) => (event.total ? event.loaded / event.total : event.loaded)),
      map((progress) => Math.ceil(progress * 10000) / 100),
      distinct()
    );

    const url$ = result$.pipe(
      filter((event) => event.type === HttpEventType.Response),
      map((event) => event as HttpResponse<{ path: string }>),
      map((event) => event.body!.path)
    );

    return concat(progress$, url$);
  }

  protected buildUploadUrl(applySvgCurrentColor: boolean): string {
    return `${environment.api.obendy}/v1/admin/upload?applySvgCurrentColor=${applySvgCurrentColor}`;
  }
}
